import ChatPromptDecision from './ChatPromptDecision';

const ChatPromptDispatcher = ({ disabled, onSubmit, prompt, response }) => {
    if (!prompt) return null;

    const inputType = prompt.input_type || prompt.action_type || 'binary';

    switch (inputType) {
        case 'binary':
            return <ChatPromptDecision disabled={disabled} onSubmit={onSubmit} prompt={prompt} response={response} />;
        case 'radio':
            //TODO: call chat prompt radio component
            break;

        case 'multiselect':
            //TODO: call chat prompt multiselect component
            break;

        default:
            console.warn(`Unsupported chat prompt type: ${inputType}`);
            return null;
    }
};

export default ChatPromptDispatcher;
